const SpecialTokenType = Object.freeze({
  NONE: 'NONE',
  TARGETED: 'TARGETED',
  LOW_LATENCY: 'LOW_LATENCY'
})
export default SpecialTokenType
// RESERVE BELOW
